var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M26.519,16.5A3.088,3.088,0,0,1,28.5,13.616a12.237,12.237,0,0,0-1.481-3.568,3.13,3.13,0,0,1-1.256.269,3.081,3.081,0,0,1-2.819-4.336A12.206,12.206,0,0,0,19.381,4.5a3.086,3.086,0,0,1-5.763,0A12.243,12.243,0,0,0,10.05,5.981a3.081,3.081,0,0,1-2.819,4.336,3.029,3.029,0,0,1-1.256-.269A12.507,12.507,0,0,0,4.5,13.623a3.086,3.086,0,0,1,.006,5.761,12.237,12.237,0,0,0,1.481,3.568,3.082,3.082,0,0,1,4.069,4.068A12.315,12.315,0,0,0,13.625,28.5a3.08,3.08,0,0,1,5.75,0,12.243,12.243,0,0,0,3.569-1.481,3.086,3.086,0,0,1,4.069-4.068,12.308,12.308,0,0,0,1.481-3.568A3.1,3.1,0,0,1,26.519,16.5Zm-9.962,4.992a5,5,0,1,1,5-5A5,5,0,0,1,16.556,21.489Z",
    transform: "translate(-4.5 -4.5)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4ee6dd89c3e42a327e012e6163d2bf09.svg";
export { ForwardRef as ReactComponent };